import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProps } from 'src/shared/prop-types/ReducerProps';

import { ThemeProvider } from 'theme-ui';
import { StickyProvider } from '../Landing/components/contexts/app/app.provider';
import agency_theme from './components/theme';
import Banner from '../Landing/components/sections/banner';
import SEO from 'src/shared/landingjs/seo';

const PnDLanding = () => {


  return (
    <ThemeProvider theme={agency_theme}>
      <StickyProvider>
        <SEO title="Informap" />
        <Banner />
      </StickyProvider>
    </ThemeProvider>
  );
};

PnDLanding.propTypes = {
  dispatch: PropTypes.func.isRequired,
  theme: ThemeProps.isRequired,
};

export default connect(state => ({ theme: state.theme }))(PnDLanding);
